import React, {useRef} from "react";
import {RiDeleteBin5Line} from "react-icons/ri";
import ReactSlider from 'react-slider';
import { findAndReturnValue, formatPrice, numberValue } from "../../../utils/helper";
import Icon from "../../../utils/Icon";
import FilterItem from "../FilterItem/FilterItem";
import styles from './Filters.module.scss';
import classnames from "classnames";

const Filters = ({
                     selectedTabOption,
                     devices,
                     rateplans,
                     screenWidth,
                     handleShowFilterSection = () => {},
                     clearFilters = () => {},
                     selectedOptions,
                     expandedSubCategories,
                     expandedCategories,
                     filterItems,
                     toggleSubCategoryExpansion = () => {},
                     toggleCategoryExpansion = () => {},
                     handleRemoveFilterOption,
                     handleFilterOptionChange,
                     handleRadioFilterOptionChange,
                     toggleCategorySelection,
                     isCheckboxVisible,
                     isFromListing=false,
                     onPriceChange,
                     minPriceRange,
                     maxPriceRange,
                     AfterPriceChange,
                     minPrice,
                     maxPrice,
                     lang
                 }) => {

    function SelectedItem({name, aggregate, onRemove, isBooleanFilter}) {
        return (
            <div className={classnames(styles.selected_item)}>
                {name} ({aggregate})
                <button className="remove-button" onClick={onRemove}>
                    ×
                </button>
            </div>

        );
    }

    function findAggregateFromFilterItems(filterItems, category, displayName) {

        const categoryObj = filterItems.find(item => item.categoryId === category);

        if (!categoryObj) return null;

        const foundItem = categoryObj.items.find(item => item.title === displayName);

        return foundItem ? foundItem.aggregate : null;
    }

    function extractFilterTitle(categoryName) {
        const categoryObj = filterItems.find(item => item.categoryId === categoryName);
        return categoryObj?.title;
    }

    function extractTitle(displayName, categoryName, lang) {
        const name = displayName === "false"
            ? lang === "en"
                ? "No"
                : "Όχι"
            : displayName === "true"
                ? lang === "en"
                    ? "Yes"
                    : "Ναι"
                : displayName
        return extractFilterTitle(categoryName)+' - '+name;
    }

    return (
        <>
            {selectedTabOption !== 'articles' && selectedTabOption !== 'support' && (screenWidth > 1200) &&
                <div className="custom-filter-col ">
                    {/* Filter */}
                    {(screenWidth > 1200) &&
                        <div
                            className="search-filter-container search-filter-panel-col mt-1 mt-sm-1 mt-md-1 mt-lg-4 mt-xl-4 normalize">
                            <div className="header-filter d-flex align-items-center justify-content-start pt-2 pt-md-0"
                                 style={{borderBottom: '1px solid #d9d9d9'}}
                                 onClick={handleShowFilterSection}>
                                <Icon name="filter" className="filter-icon" width="23px" height="23px"/>
                                <div className="p2">{lang === "en" ? "Filters":"Φίλτρα"}</div>
                                {console.log(lang)}
                            </div>

                            {Object.entries(selectedOptions).length > 0 && isFromListing===false && (
                            <div
                                className="header-filter d-flex align-items-center justify-content-between pt-2 pt-md-0"
                                onClick={handleShowFilterSection}>
                                <div className="p3">{lang === "en"? "Applied filters":"Φίλτρα σε εφαρμογή"}</div>
                                <RiDeleteBin5Line
                                    className="clear-filter-button"
                                    style={{color: '#000'}}
                                    onClick={() => clearFilters()}
                                    size={20}
                                />
                            </div>
                            )}
                            {/* ONLY for DESKTOP */}
                            <div className="selected-items-container desktop">
                                <div className={classnames(styles.selected_filters)}>
                                    {Object.entries(selectedOptions).flatMap(([category, values]) =>
                                        values.map((value, index) => (
                                            (!(isFromListing && rateplans?.count > 0 && category === "categoryPath")) &&
                                            <SelectedItem
                                                key={`${category}-${value.category}-${index}`}
                                                name={(value.displayName === "true" || value.displayName === "false")
                                                    ? extractTitle(value.displayName,category, lang) : value.displayName}
                                                aggregate = {findAggregateFromFilterItems(filterItems,category,value.displayName)}
                                                onRemove={() => handleRemoveFilterOption(category, value.category)}
                                            />
                                            )
                                        )
                                    )}
                                </div>

                                {isFromListing === true &&
                                    <div className="clear-filter-label">
                                        <a className="clear-all-btn color-secondarybluenavy"

                                           onClick={clearFilters}>
                                            Καθαρισμός Φίλτρων
                                        </a>
                                    </div>
                                }

                                {filterItems.map((item, index) =>
                                        (!(isFromListing && rateplans?.count > 0 && item?.categoryId === "categoryPath")) && (
                                            <FilterItem
                                                clearFilters={clearFilters}
                                                item={item}
                                                isExpanded={expandedCategories[item.title]}
                                                toggleCategoryExpansion={toggleCategoryExpansion}
                                                toggleSubCategoryExpansion={toggleSubCategoryExpansion}
                                                selectedOptions={selectedOptions}
                                                key={index}
                                                isSubExpanded={expandedSubCategories[item.title]}
                                                handleFilterOptionChange={handleFilterOptionChange}
                                                handleRadioFilterOptionChange={handleRadioFilterOptionChange}
                                                expandedSubCategories={expandedSubCategories}
                                                toggleCategorySelection={toggleCategorySelection}
                                                isCheckboxVisible={isCheckboxVisible}
                                                isFromListing={isFromListing}
                                                lang={lang}
                                            />
                                        )
                                )}

                                {isFromListing && minPriceRange > 0 && maxPriceRange > 0 &&(
                                    <div className="slider-container">
                                        <div className="filter-category-title">TIMOULA</div>
                                        <ReactSlider
                                            className="horizontal-slider"
                                            thumbClassName="thumb"
                                            trackClassName="track"
                                            value={[numberValue(minPrice > -1 ? minPrice : minPriceRange),
                                                numberValue(maxPrice > -1 ? maxPrice : maxPriceRange)]}
                                            onChange={onPriceChange}
                                            onAfterChange={AfterPriceChange}
                                            min={minPriceRange}
                                            max={maxPriceRange}
                                            pearling
                                            step={0.05}
                                            renderThumb={({key, ...props}, _) => <div key={key} {...props}></div>}
                                        />
                                        <div>
                                            minimum
                                            {` ${formatPrice(minPrice > -1 ? minPrice : minPriceRange)} `}
                                            ews
                                            {` ${formatPrice(maxPrice > -1 ? maxPrice : maxPriceRange)}`}
                                        </div>
                                    </div>

                                )}
                            </div>
                        </div>
                    }
                </div>
            }
        </>
    );

};

export default Filters;
